export const LADE_AUSWAHLWERTE_DEBITOR = "ladeAuswahlwerteDebitor";